import { Tag } from 'antd'
import { FC } from 'react'
import { OrderStatus } from '../../../../../types/api/stamp-order'

interface StampOrderOrderStatusCellProps {
    orderStatus: OrderStatus
}

const orderStatusColor: Record<OrderStatus, string> = {
    Создан: 'default',
    Заказан: 'blue',
    'В сборке': 'gold',
    'В пути': 'geekblue',
    'Готов к выдаче': 'cyan',
    Завершен: 'green',
    Отменен: 'red',
}

const StampOrderOrderStatusCell: FC<StampOrderOrderStatusCellProps> = ({ orderStatus }) => {
    return (
        <Tag color={orderStatusColor[orderStatus]} style={{ margin: 0 }}>
            {orderStatus}
        </Tag>
    )
}

export default StampOrderOrderStatusCell
